import _ from 'underscore';
import { STREAMSERVE_EVENTS } from '../../modules/streamserve_events.js';

const onReady = (session) => {
  document.dispatchEvent(new CustomEvent(STREAMSERVE_EVENTS.STREAMING_CONTEXT_REQUEST));
};

angular.module('vastdesk').controller('DemandTagServerSideTableController', ['$scope', function ($scope) {
  $scope.demandTagBulkActionDisabledConditions = {
    onlyProgrammaticGuaranteedSelected: false,
  };

  function syncProgrammaticGuaranteedCreateUrl(event) {
    const url = event?.detail?.url ?? null;

    if ($scope.programmaticGuaranteedCreateUrl === url) {
      return;
    }

    $scope.$evalAsync(function () {
      $scope.programmaticGuaranteedCreateUrl = url;
    });
  }

  function requestProgrammaticGuaranteedUrl() {
    document.dispatchEvent(new CustomEvent(STREAMSERVE_EVENTS.STREAMING_CONTEXT_REQUEST));
    
    const session = window.__communicatorSession;
    if (session && !session.isConnected) {
      session.on('connected', onReady);
      session.on('reconnected', onReady);
    }
  }

  document.addEventListener(STREAMSERVE_EVENTS.STREAMING_CONTEXT_CHANGE, syncProgrammaticGuaranteedCreateUrl);
  requestProgrammaticGuaranteedUrl();
  $scope.$on('$destroy', function () {
    document.removeEventListener(STREAMSERVE_EVENTS.STREAMING_CONTEXT_CHANGE, syncProgrammaticGuaranteedCreateUrl);
  });

  $scope.handleProgrammaticGuaranteedClick = function (event) {
    if (window.__handleUnifiedDemandLinkClick) {
      window.__handleUnifiedDemandLinkClick(event);
    }
  };


  const serverSideTable = $('#demand_tags_table');
  let allProgrammaticGuaranteedTagIds = [];

  serverSideTable.on('xhr.dt', function(e, settings, json, xhr) {
    if (json && json.custom_data && json.custom_data.programmatic_guaranteed_tag_ids) {
      allProgrammaticGuaranteedTagIds = json.custom_data.programmatic_guaranteed_tag_ids;
    }
  });

  $scope.$watchCollection('selectedDemandTagBulkActionIds', function (new_val, old_val) {
    if (!Array.isArray(new_val) || !Array.isArray(allProgrammaticGuaranteedTagIds)) {
      return;
    }

    $scope.demandTagBulkActionDisabledConditions.onlyProgrammaticGuaranteedSelected = _.difference(new_val, allProgrammaticGuaranteedTagIds).length === 0;
  });
}]);
